/* Before/after comparison. The split is driven by a real range input, so
   dragging, tapping and arrow keys all work without custom pointer handling —
   the script only mirrors the input's value onto a CSS custom property. */
(function () {
  function init(root) {
    if (root.dataset.compareReady === 'true') return;

    var range = root.querySelector('[data-compare-range]');
    if (!range) return;

    root.dataset.compareReady = 'true';

    function update() {
      root.style.setProperty('--compare-pos', range.value + '%');
    }

    range.addEventListener('input', update);
    update();
  }

  document.querySelectorAll('[data-compare]').forEach(init);

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-compare]').forEach(init);
  });
})();
